export class MessagingConstants {
  static selectionInfo: string = 'selectionInfo';
  static sceneProvider: string = 'sceneProvider';
  static startRoundAnimation: string = 'StartAnimation';
  static finishRoundAnimation: string = 'FinishAnimation';
  static bonusType: string = 'bonusType';
  static allIndexes: string = 'allIndexes';
  static allIds: string = 'allIds';
  static selectedIds: string = 'selectedIds';
  static allSelectedIds: string = 'allSelectedIds';
  static notSelectedIds: string = 'notSelectedIds';
  static selectedIndexes: string = 'selectedIndexes';
  static firstSelectedIndex: string = 'firstSelectedIndex';
  static lastSelectedIndex: string = 'lastSelectedIndex';
  static allSelectedIndexes: string = 'allSelectedIndexes';
  static notSelectedIndexes: string = 'notSelectedIndexes';
  static randomNotSelectedIndex: string = 'randomNotSelectedIndex';
  static selectedViews: string = 'selectedViews';
  static notSelectedViews: string = 'notSelectedViews';

  static selectedExtraValues: string = 'selectedExtraValues';
  static notSelectedExtraValues: string = 'notSelectedExtraValues';

  static winIndexes: string = 'winIndexes';
  static loseIndexes: string = 'loseIndexes';
  static notSelectedWinIndexes: string = 'notSelectedWinIndexes';
  static notSelectedLoseIndexes: string = 'notSelectedLoseIndexes';

  static dealerCards: string = 'dealerCards';
  static selectedCards: string = 'selectedCards';
  static notSelectedCards: string = 'notSelectedCards';
  static selectedTypes: string = 'selectedTypes';
  static firstSelectedType: string = 'firstSelectedType';
  static lastSelectedType: string = 'lastSelectedType';
  static firstSelectedRoutingIndex: string = 'firstSelectedRoutingIndex';
  static lastSelectedRoutingIndex: string = 'lastSelectedRoutingIndex';

  static notSelectedTypes: string = 'notSelectedTypes';
  static selectedValues: string = 'selectedValues';
  static selectedTotalValues: string = 'selectedTotalValues';
  static selectedRoutingIndexes: string = 'selectedRoutingIndexes';
  static firstSelectedValue: string = 'firstSelectedValue';
  static lastSelectedValue: string = 'lastSelectedValue';
  static lastSelectedView: string = 'lastSelectedView';
  static firstSelectedView: string = 'firstSelectedView';
  static firstSelectedTotalValue: string = 'firstSelectedTotalValue';
  static lastSelectedTotalValue: string = 'lastSelectedTotalValue';
  static notSelectedValues: string = 'notSelectedValues';
  static notSelectedTotalValues: string = 'notSelectedTotalValues';
  static notSelectedRoutingIndexes: string = 'notSelectedRoutingIndexes';

  static selectedButtonsSet: string = 'selectedButtonsSet';
  static clickedButtonIndex: string = 'clickedButtonIndex';
  static roundNumber: string = 'serverIndex';
  static previousRoundNumber: string = 'previousServerIndex';
  static roundType: string = 'roundType';
  static userFriendlyRoundNumber: string = 'userFriendlyRoundNumber';
  static bonusRecovery: string = 'bonusRecovery';
  static bonusFinished: string = 'bonusFinished';
  static bonusStarted: string = 'bonusStarted';
  static winName: string = 'winName';
  static attempts: string = 'attempts';
  static nextAttempts: string = 'nextAttempts';
  static attemptsUsed: string = 'attemptsUsed';
  static bonusWin: string = 'bonusWin';
  static totalWin: string = 'totalWin';
  static additionWin: string = 'additionWin';
  static bet: string = 'bet';
  static lines: string = 'lines';
  static totalBet: string = 'totalBet';
  static formula: string = 'formula';
  static totalBetWithMultiplier: string = 'totalBetWithMultiplier';
  static type: string = 'type';
  static multiplier: string = 'multiplier';

  static random: string = 'random';
  static randomUnused: string = 'randomUnused';
  static randomComponent: string = 'randomComponent';

  static historyItemsIds: string = 'historyItemsIds';
  static historyItemsValues: string = 'historyItemsValues';

  static PaytableTypeKey: string = 'paytableTypes';
  static paytableIndexesKey: string = 'paytableIndexes';
  static paytableValuesKey: string = 'paytableValues';
  static paytableTotalValuesKey: string = 'paytableTotalValues';
  static selectedPaytableKey: string = 'selectedPaytable';
  static selectedPaytableIndexesKey: string = 'selectedPaytableIndexes';
  static notSelectedPaytableKey: string = 'notSelectedPaytable';
  static notSelectedPaytableIndexesKey: string = 'notSelectedPaytableIndexes';
  static paytableExtraValuesKey: string = 'paytableExtraValues';

  static freeSpinsCount: string = 'freeSpinsCount';
  static wonFreeSpins: string = 'wonFreeSpins';

  static multipleRoundStart: string = 'multipleRoundStart';

  static serverSelectedValues: string = 'serverSelectedValues';
  static serverSelectedIndexes: string = 'serverSelectedIndexes';
  static serverSelectedTypes: string = 'serverSelectedTypes';
  static serverSelectedViews: string = 'serverSelectedViews';
}
